<template>
  <BootstrapModal
    class="CreateDiscount"
    :disableButton="true"
    :remove-padding="true"

    v-on="$listeners"
  >
    <template #title>
      Korting toevoegen
    </template>

    <SetupStepsSidebar
      :steps="steps"
      :modal="true"
      ref="discount-steps"

      @save-form="createDiscount"
    >
      <template #icon-discount-details>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 48 48">
          <g transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"><g>
            <path d="M8.5.5h-7a1,1,0,0,0-1,1v11a1,1,0,0,0,1,1h11a1,1,0,0,0,1-1v-7Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
            <path d="M8.5,5V.5l5,5H9A.5.5,0,0,1,8.5,5Z" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
            <line x1="4.5" y1="4.5" x2="4.5" y2="3" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
            <path d="M3,8.5c0,.75.67,1,1.5,1S6,9.5,6,8.5C6,7,3,7,3,5.5c0-1,.67-1,1.5-1S6,4.88,6,5.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></path>
            <line x1="4.5" y1="9.5" x2="4.5" y2="11" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
            <line x1="8.5" y1="9.5" x2="11.5" y2="9.5" style="fill: none;stroke: currentColor;stroke-linecap: round;stroke-linejoin: round"></line>
          </g></g>
        </svg>
      </template>
      <template #icon-products>
        <svg width="16" height="16" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M2.02979 9V13.5C2.02979 13.6326 2.08246 13.7598 2.17623 13.8536C2.27 13.9473 2.39718 14 2.52979 14H12.5298C12.6624 14 12.7896 13.9473 12.8833 13.8536C12.9771 13.7598 13.0298 13.6326 13.0298 13.5V9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M8.52979 9V14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2.02979 10.5H8.52979" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M1.02979 4.5L2.52979 1H12.5298L14.0298 4.5H1.02979Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.28 4.5V5.5C5.28 6.03043 5.06929 6.53914 4.69421 6.91421C4.31914 7.28929 3.81043 7.5 3.28 7.5H3C2.46957 7.5 1.96086 7.28929 1.58579 6.91421C1.21071 6.53914 1 6.03043 1 5.5V4.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.77979 4.5V5.5C9.77979 6.03043 9.56907 6.53914 9.194 6.91421C8.81893 7.28929 8.31022 7.5 7.77979 7.5H7.27979C6.74935 7.5 6.24064 7.28929 5.86557 6.91421C5.4905 6.53914 5.27979 6.03043 5.27979 5.5V4.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M14.0298 4.5V5.5C14.0298 6.03043 13.8191 6.53914 13.444 6.91421C13.0689 7.28929 12.5602 7.5 12.0298 7.5H11.7798C11.2494 7.5 10.7406 7.28929 10.3656 6.91421C9.9905 6.53914 9.77979 6.03043 9.77979 5.5V4.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </template>

      <template>
        <DiscountDetails v-model="discountDetails" class="disable-ske"/>
        <div>
          <ProductFinder v-model="products" :remove-inputs='true'/>
        </div>
      </template>
    </SetupStepsSidebar>
  </BootstrapModal>
</template>

<script>

import BootstrapModal from "../BootstrapModal.vue"
import SetupStepsSidebar from "../../SetupStepsSidebar/SetupStepsSidebar.vue"

import ProductFinder from "../../../components/Product/ProductFinder/ProductFinder.vue"
import DiscountDetails from "./EditOrder/DiscountDetails.vue"

import { fixCommaFloatingPointNumber } from "src/mixins/fixDecimalCommaNotation"

export default {
  components: {
    DiscountDetails,
    BootstrapModal,
    SetupStepsSidebar,
    ProductFinder,
  },
  props: {
    callback: Function,
  },
  data() {
    return {
      discountDetails: { apply_to_shipping: false },
      products: [],

      steps: [
        {
          name: "Kortingsdetails",
          id: "discount-details",
        },
        {
          name: "Producten",
          id: "products",
        },
      ],
    }
  },
  methods: {
    async createDiscount() {
      const details = {
        ...this.discountDetails,

        value: fixCommaFloatingPointNumber(this.discountDetails.discount_value),
      }
      delete details.discount_value
      const products = this.products

      await this.$handlePromise(async () => {
        await this.axios.post("/api/discounts", {
          ...details,

          products: products.map(item => item.sku),
        })
        this.$store.dispatch('clearCacheSearch', "discounts")

        this.$success("Korting toegevoegd!")
        this.callback()
        this.$emit("close")
      })
    },
  },
  watch: {
    products(val) {
      if (val.length) {
        this.$refs["discount-steps"].removeIndexError(1)
      }
    },
  },
}

</script>

<style scoped>

.CreateDiscount {
  flex-basis: 1300px;
  min-height: 600px;
}

@media (min-width: 769px) {
  .CreateDiscount {
    min-height: 800px;
  }
}

@media (max-width: 400px) {
  .CreateDiscount {
    min-height: 400px;
  }
}

</style>
